// extracted by mini-css-extract-plugin
export default {"container":"styles__container--3ydJE","fixed":"styles__fixed--NHAw+","message":"styles__message--Zn3k1","action":"styles__action--ycz2G"};